/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.25/esri/copyright.txt for details.
*/
import{glsl as a}from"../../shaderModules/interfaces.js";function o(o){const e=a`bool isNaN( float val )
{
return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true;
}`;o.code.add(e)}export{o as IsNaN};
